module.exports = __webpack_public_path__ + "static/media/scroll3_5.03d018f4.png";